import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/login/Login'
import Main from '@/views/main/Main'
import IFrame from '../views/main/IFrame'
import Error404 from '@/views/error/404'
import UserList from '@/views/system/user/UserList'
import LoginLogList from '@/views/system/loginLog/LoginLogList'
import OperLogList from '@/views/system/operLog/OperLogList'
import ConfigList from '@/views/system/config/ConfigList'
import MenuList from '@/views/system/menu/MenuList'
import RoleList from '@/views/system/role/RoleList'

//解决相同的路由报错问题
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [{
    //默认登录页面
    path: '/',
    component: Login
  }, {
    //主页
    path: '/main',
    component: Main,
    children: [{
      //用户
      path: 'user',
      component: UserList
    }, {
      //登录日志
      path: 'loginLog',
      component: LoginLogList
    }, {
      //操作日志
      path: 'operLog',
      component: OperLogList
    }, {
      //数据字典
      path: 'config',
      component: ConfigList
    }, {
      //菜单管理
      path: 'menu',
      component: MenuList
    }, {
      //角色管理
      path: 'role',
      component: RoleList
    }, {
      //系统参数
      path: 'params',
      component: () => import('@/views/qcld/params/Params')
    }, {
      //隐私协议
      path: 'privacyAgreement',
      component: () => import('@/views/qcld/agreement/PrivacyAgreement')
    }, {
      //用户协议
      path: 'userAgreement',
      component: () => import('@/views/qcld/agreement/UserAgreement')
    },{
      //充值协议
      path: 'rechargeAgreement',
      component: () => import('@/views/qcld/agreement/RechargeAgreement')
    }, {
      //光照记录
      path: 'light',
      component: () => import('@/views/qcld/light/LightList')
    }, {
      //运动记录
      path: 'sport',
      component: () => import('@/views/qcld/sport/SportList')
    }, {
      //光度值管理
      path: 'lightExplain',
      component: () => import('@/views/qcld/lightExplain/LightExplainList')
    }, {
      //用户分类管理
      path: 'userType',
      component: () => import('@/views/qcld/userType/UserTypeList')
    }, {
      //客服管理
      path: 'customer',
      component: () => import('@/views/qcld/customer/CustomerList')
    }, {
      //软件包管理
      path: 'app',
      component: () => import('@/views/qcld/app/AppList')
    }, {
      //短信发送记录
      path: 'smsSend',
      component: () => import('@/views/qcld/smsSend/SmsSendList')
    }, {
      //设备管理
      path: 'device',
      component: () => import('@/views/qcld/device/DeviceList')
    }, {
      //用户管理
      path: 'user2',
      component: () => import('@/views/qcld/user/UserList')
    }, {
      //默认头像组
      path: 'avatarGroup',
      component: () => import('@/views/qcld/avatarGroup/AvatarGroupList')
    }, {
      //每日运动步数
      path: 'sportDay',
      component: () => import('@/views/qcld/sportDay/SportDayList')
    }, {
      // 硬件设备
      path: 'deviceLife',
      component: () => import('@/views/qcld/deviceLife/DeviceLifeList')
    }, {
      // 用户任务
      path: 'sportsTask',
      component: () => import('@/views/qcld/sportsTask/SportsTaskList')
    },  {
      // 运动硬件数据
      path: 'sportsData',
      component: () => import('@/views/qcld/sportsData/SportsDataList')
    }, {
      // 设备任务
      path: 'sportsTaskPush',
      component: () => import('@/views/qcld/sportsTaskPush/SportsTaskPushList')
    }, {
      // 孩子睡眠记录
      path: 'childSleep',
      component: () => import('@/views/qcld/childSleep/ChildSleepList')
    }, {
      // 孩子身高记录
      path: 'childHeight',
      component: () => import('@/views/qcld/childHeight/ChildHeightList')
    }, {
      // 孩子视力记录
      path: 'childEyesight',
      component: () => import('@/views/qcld/childEyesight/ChildEyesightList')
    }, {
      // 孩子全面身高
      path: 'overallHeight',
      component: () => import('@/views/qcld/overallHeight/OverallHeightList')
    }, {
      //首页
      path: 'main',
      component: () => import('@/views/qcld/main/Main')
    },{
      //统计页面
      path: 'statistics',
      component: () => import('@/views/qcld/statistics/operational')
    }, {
      //菜单跳转第三方链接地址iframe
      path: 'iframe',
      component: IFrame
    }, {
      //404错误页面
      path: '404',
      component: Error404
    }, {
      //找不到页面统一跳转
      path: '*',
      redirect: '404'
    }]
  }, {
    //知识说明
    path: '/knowledge',
    component: Main,
    children: [{
      path: 'type',
      component: () => import('@/views/knowledge/type/KnowledgeTypeList')
    },{
      path: 'tag',
      component: () => import('@/views/knowledge/knowledgeTag/KnowledgeTagList')
    },{
      path: 'knowledge',
      component: () => import('@/views/knowledge/knowledge/KnowledgeList')
    }]
  }, {
    //会员
    path: '/vip',
    component: Main,
    children: [{
      path: 'config',
      component: () => import('@/views/vip/vipConfig/VipConfigList')
    },{
      path: 'recharge',
      component: () => import('@/views/vip/vipRechargeRecord/VipRechargeRecordList')
    },{
      path: 'exchange',
      component: () => import('@/views/vip/vipActivateConfig/VipActivateConfigList')
    },{
      path: 'vipBenefits',
      component: () => import('@/views/vip/vipBenefits/VipBenefitsList')
    }]
  }, {
    //内容管理
    path: '/textConfig',
    component: Main,
    children: [{
      path: 'list',
      component: () => import('@/views/qcld/textConfig/TextConfigList')
    }]
  }, {
    //任务点管理
    path: '/sys',
    component: Main,
    children: [{
      path: 'taskPoint',
      component: () => import('@/views/task/taskPoint/TaskPointList')
    }]
  },{
    //学员任务
    path: '/child',
    component: Main,
    children: [{
      path: 'dailTask',
      component: () => import('@/views/task/dailTask/managerChild')
    }]
  },{
    //任务模板快照
    path: '/child',
    component: Main,
    children: [{
      path: 'childTemplateSnapshot',
      component: () => import('@/views/task/childTemplateSnapshot/ChildTemplateSnapshotList')
    }]
  }, {
    //场景管理
    path: '/scene',
    component: Main,
    children: [{
      path: 'config',
      component: () => import('@/views/qcld/lightSceneConfig/LightSceneConfigList')
    }]
  },{
    //链接信息
    path: '/mqtt',
    component: Main,
    children: [{
      path: 'connect',
      component: () => import('@/views/qcld/device/connectInfo')
    }]
  },{
    //公告
    path: '/system',
    component: Main,
    children: [{
      path: 'notice',
      component: () => import('@/views/qcld/params/Notice')
    }]
  },{
    //404错误页面
    path: '/404',
    component: Error404
  }, {
    //找不到页面统一跳转
    path: '*',
    redirect: '/404'
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js